__turbopack_context__.v({
  "browse-showtimes": "trailer-dialog-module-scss-module__y_kvdG__browse-showtimes",
  "modal-body": "trailer-dialog-module-scss-module__y_kvdG__modal-body",
  "modal-content": "trailer-dialog-module-scss-module__y_kvdG__modal-content",
  "modal-footer": "trailer-dialog-module-scss-module__y_kvdG__modal-footer",
  "modal-footer--empty": "trailer-dialog-module-scss-module__y_kvdG__modal-footer--empty",
  "modal-footer--single": "trailer-dialog-module-scss-module__y_kvdG__modal-footer--single",
  "showtime-grid": "trailer-dialog-module-scss-module__y_kvdG__showtime-grid",
  "showtime-list": "trailer-dialog-module-scss-module__y_kvdG__showtime-list",
  "starting-soon": "trailer-dialog-module-scss-module__y_kvdG__starting-soon",
});
